<template>
  <component
    v-if="component"
    :is="component"
    :size="size"
    :fill="fill"
    :autoMargin="autoMargin"
  ></component>
</template>

<script>
import colors from 'vuetify/lib/util/colors';
export default {
  props: {
    icon: {},
    size: { default: '28' },
    color: { default: 'grey' },
    autoMargin: { default: true }
  },
  data() {
    return {
      iconMap: {
        context: 'ContextIcon'
      },
      component: null
    };
  },
  mounted() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {
        this.component = null;
      });
  },
  computed: {
    loader() {
      if (!this.icon) {
        return null;
      }
      return () => import(`@/components/CIcon/${this.iconMap[this.icon]}`);
    },
    fill() {
      //  pass in the normal 'blue lighten-2
      const colorArray = this.color.split(' ');
      const c = colorArray[0];
      const adjust = colorArray[1] ? colorArray[1].replace('-', '') : 'base';
      return colors[c][adjust];
    }
  }
};
</script>

<style></style>
